export enum QueryKey {
  VVS_MOLE_IS_SALE_ACTIVE = 'mole-contract:sale-active',
  VVS_MOLE_CURRENT_SALE_PHASE = 'mole-contract:sale-phase',
  VVS_MOLE_USER_TOKENS = 'mole-contract:user-minted-tokens',
  VVS_MOLE_USER_TOKEN_LENGTH = 'mole-contract:user-minted-token-length',
  TOKEN_BALANCE_QUERY = 'token-balance-query',
  IS_CHAIN_CORRECT = 'is-chain-correct',
  BALANCE_OF_USER = 'balance-of-user',
  TOKEN_OF_USER_BY_INDEX = 'token-of-user-by-index',
  VVS_INFO_API_META_MOLE_LIST = 'vvs_info_api_meta_mole_list',
  VVS_MOLE_APPROVAL_FOR_ALL = 'mole-contract:approval-for-all',
  VVS_MOLE_APPROVAL_IS_FOR_ALL = 'mole-contract:is-approval-for-all',

  // rewarderV2
  REWARDER_V2_GET_BOOST_FACTOR = 'rewarderV2:viewBoostFactor',
  REWARDER_V2_VIEW_POOL_INFO = 'rewarderV2:viewPoolInfo',
  REWARDER_V2_VIEW_USER_INFO = 'rewarderV2:getUserInfo',
  REWARDER_V2_ARGO_APPROVAL_IS_FOR_ALL = 'rewarderV2:argo-is-approval-for-all',
  VVS_INFO_API_META_USER_NFT_COLLECTIONS = 'vvs_info_api_meta_user_nft_collections',

  // vvsgotchi
  VVS_GOTCHI_OWNER = 'vvsgotchi-owner',
  VVS_GOTCHI_QUESTS = 'vvsgotchi-quests',
}
